/** @prettier */
import React from "react";
import ProgressBar from "./ProgressBar";

type TestViewProps = {
    titleBar: JSX.Element;
    children: JSX.Element;
    summaryBar: JSX.Element;
    actionBar: JSX.Element;
    percent: number;
    id: string;
};
const TestView = ({
    titleBar,
    percent,
    children,
    summaryBar,
    actionBar,
    id,
}: TestViewProps) => {
    return (
        // TODO: clean CSS
        <div id={id} className="test-view">
            {titleBar}
            <ProgressBar percent={percent} />
            <div className="tr-main">
                {summaryBar}
                <div className="tr-content">
                    {children}
                    {actionBar}
                </div>
            </div>
        </div>
    );
};

export default TestView;
